import { CLIENTS } from "@/data/content";
import { Reveal } from "./Reveal";

const Clients = () => {
  return (
    <section data-testid="clients-section" className="bg-[#0A1428] py-16 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="text-center text-xs uppercase tracking-[0.3em] text-gray-500 mb-10">
            Trusted by ambitious small businesses
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6">
            {CLIENTS.map(({ name, icon: Icon }) => (
              <div
                key={name}
                data-testid={`client-${name}`}
                className="group flex items-center gap-2.5 text-white/40 hover:text-white/80 transition-colors duration-300"
              >
                <span className="w-9 h-9 rounded-lg border border-white/10 group-hover:border-[#1E6BFF]/40 flex items-center justify-center transition-colors duration-300">
                  <Icon size={18} strokeWidth={1.75} className="group-hover:text-[#1E6BFF] transition-colors duration-300" />
                </span>
                <span className="font-display font-bold text-lg md:text-xl tracking-tight">{name}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Clients;
